// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tEB92","right":"styles_right__3JKIl"};